import { accessibility } from "./modules/accessibility";
import { bannerForms } from "./modules/bannerForms";
import { counter } from "./modules/counter";
import { devicecheck } from "./modules/devicecheck";
import { dialog } from "./modules/dialog";
import { facts } from "./modules/facts";
import { iframeHeightCalc } from "./modules/iframeHeightCalc";
import { lightbox } from "./modules/lightbox";
import { megaNav } from "./modules/megaNav";
import { nav } from "./modules/nav";
import { onScroll } from "./modules/onScroll";
import { openFilter } from "./modules/openFilter";
import { partnerLogo } from "./modules/partnerLogo";
import { preload } from "./modules/preload";
import { priceRequest } from "./modules/priceRequest";
import { slider } from "./modules/slider";
import { stoerer } from "./modules/stoerer";
import { toggleItem } from "./modules/toggleItem";

window.onload = function () {
  slider();
  onScroll();
  preload();
  nav();
  megaNav();
  openFilter();
  lightbox();
  counter();
  dialog();
  stoerer();
  toggleItem();
  facts();
  bannerForms();
  accessibility();
  iframeHeightCalc();
  devicecheck();
  partnerLogo();
  priceRequest();
};
